import { useContextInspectionDetail } from "components/containers/inspectionDetail/context/inspectionDetail";
import useForgeLabel from "components/containers/inspectionDetail/hooks/useForgeLabel";
import { Pin } from "interfaces/models/pin";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

interface Props {
  pins: Pin[];
}

const useShowPinLabels = (props: Props) => {
  const { pins } = props;

  const { isLoadedViewerModelData, isLoadedSheetTransformRatio } = useSelector(
    (state: RootState) => state.forgeViewer
  );

  const { clearPinLabels, showPinLabels } = useForgeLabel();

  const { forgeViewerData } = useContextInspectionDetail();

  // show labels
  useEffect(() => {
    if (
      !isLoadedViewerModelData ||
      !pins?.length ||
      !forgeViewerData?.guid ||
      !isLoadedSheetTransformRatio
    ) {
      return;
    }

    showPinLabels(pins);

    return () => {
      clearPinLabels();
    };
  }, [
    forgeViewerData.guid,
    pins,
    isLoadedViewerModelData,
    isLoadedSheetTransformRatio,
    clearPinLabels,
    showPinLabels,
  ]);

  return {};
};

export default useShowPinLabels;
